module.exports = __webpack_public_path__ + "img/notice.78402fa8.png";